/**
 * Created by Victor Rojo on 15/10/18.
 */
import { Injectable }     from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {IPlaceService} from "./iPlace.service";


@Injectable()
export class IPlaceValuelistService {

  private valuelist: any = {};

  constructor(
    private service: IPlaceService
  ){ }

  reload() {
    return this.service.get().then(page => {
      this.valuelist = page.content.reduce((previous:any, current:any) => {
        previous[current.id] = current;
        return previous;
      }, {})
    }).catch(error => error);
  }

  addValue(object: any) {
    this.valuelist[object.id] = object;
  }

  clear() {
    this.valuelist = {};
  }

  updateValue(id:any, data:any) {
    if ( this.valuelist[id] ) {
      (<any>Object).keys(data).forEach( (field:string) => {
        this.valuelist[id][field] = data[field];
      });
    }
  }

  deleteValue(id:any) {
    this.valuelist[id] = null;
    delete this.valuelist[id];
  }

  getValuelist(){
    return this.valuelist;
  }
}
